import React from 'react';

// ** Components
import { MainLayout } from 'components';

// ** Hooks
import { usePartnersData } from 'data/hooks/partners/use-partners-data';

// ** Components
import { PreviewSection, About, PartnersList, JoinUs } from 'sections/partners';

const Partners = () => {
  const { metaData } = usePartnersData();

  return (
    <MainLayout meta={metaData}>
      <PreviewSection />
      <About />
      <PartnersList />
      <JoinUs />
    </MainLayout>
  );
};

export default Partners;
